import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UmsService } from '../ums.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
 
@Component({
  selector: 'app-pay-later',
  templateUrl: './pay-later.component.html',
  styleUrls: ['./pay-later.component.scss']
})
export class PayLaterComponent implements OnInit {
  PayLateForm: FormGroup;
  APIService: string;
  PayLateGrid: FormArray;
  errMsg: any;
  submitpayload: any;
  dialogRef: MatDialogRef<any>;
  FeeLevel: any;
  filteredElements: any[];
  FeeDetails: any;
  DeleteNull: boolean;
  constructor(private modalPopupService: ModalpopService,
    public umsService: UmsService, private httpClient: HttpClient,
    private fb: FormBuilder, public router: Router,@Inject(MAT_DIALOG_DATA) public data: any,
    private route: ActivatedRoute, private spinner: NgxSpinnerService,) { this.APIService = environment.serviceUrl; }
 
 
  ngOnInit(): void {
    this.PayLateForm = this.fb.group({
      PayLateGrid: new FormArray([]),
    });
    this.getGrid(this.data);
  }
 
  getPayLateGridControls() {
    return (this.PayLateForm.get('PayLateGrid') as FormArray).controls;
  }
 
  getGrid(data){
    let payload = {}
      payload['SessionId'] = data[0]['SnNo'];
      payload['CoCode'] = data[0]['CoCode'];
      payload['CgCode'] = data[0]['CgCode'];
      payload['StuId'] = 0;
      payload['FeeType'] = 'EF';
      payload['EmId'] = data[0]['EmId']
      this.umsService.getFeeDetails(payload).subscribe((res) => {
        const studentData = res.data;
        this.FeeDetails = res.data;
        const studentMap = new Map<number, any>();
 
        studentData.forEach(record => {
          const key = record.StuId;
          if (!studentMap.has(key)) {
            studentMap.set(key, record);
          }
        });
          // Validate records for each student
        //   studentMap.forEach((records, key) => {
           
        //     const invalidRecord = records.find(record => record.TemplateCode != null);
        // })
        studentMap.forEach(element => {
          this.PayLateGrid = this.PayLateForm.get('PayLateGrid') as FormArray;
          this.PayLateGrid.push(
            this.fb.group({
              name: new FormControl(element['StuFirstNameEng'] + ' ' + element['StuMidNameEng'] + ' ' + element['StuLastNameEng']),
              StuId: new FormControl(element['StuId']),
              FeeHead: new FormControl(element['Head']),
              FeeType: new FormControl('EF'),
              FeeAmt: new FormControl(element['FeeAmount']),
              FeePaid: new FormControl(0),
              FeeDueCal: new FormControl(element['FeeAmount']),
              FeeDue: new FormControl(element['FeeAmount']),
              FeePaymentMethod: new FormControl(''),
              PayMode: new FormControl(''),
              CreatedBy: new FormControl(''),
              TemplateCode: new FormControl(element['TemplateCode']),
              // TotalPaidAmount: new FormControl(element['TotalPaidAmount']),
              TotalPaidAmount: new FormControl(element['TotalPaidAmount'] ? 'Paid' : 'Pending'),
              FeeStatus: new FormControl(element.FeeStatus),
              TotalFeeAmount: new FormControl(element.TotalFeeAmount),
              Status: new FormControl(element['TotalPaidAmount'] ? 'Y' : '')
            })
          );
       
        });
      })
   
  }
 
  onCheckboxChange(checked: boolean, index: number) {
    const statusControl = (this.PayLateForm.get('PayLateGrid') as FormArray).at(index).get('FeeStatus');
    const status = (this.PayLateForm.get('PayLateGrid') as FormArray).at(index).get('Status');
    // Check if the checkbox is disabled before handling the change event
    if (!statusControl.disabled) {
        if (checked) {
            statusControl.setValue('N');
            status.setValue('N')
        } else {
            statusControl.setValue('');
            status.setValue('')
        }
    }
}
 
  Save(){
    this.submitpayload = this.PayLateForm.value;
    let abcd = this.PayLateForm.get('PayLateGrid') as FormArray;
    let payload = abcd.value;
    let iserror = false;
    const stuidsWithStatusN = payload.filter(item => item.FeeStatus === 'N')
    const stuidsNull = payload.filter(item => item.FeeStatus === null || item.FeeStatus === '')
    const filteredData = this.FeeDetails.filter(item => stuidsWithStatusN.some(statusItem => statusItem.StuId === item.Studentid));
    const filteredNullData = this.FeeDetails.filter(item => stuidsNull.some(statusItem => statusItem.StuId === item.Studentid));
    this.DeleteNull = false;
    if(filteredNullData){
      this.deleteNull(filteredNullData)
    }
    if(filteredData){
      this.delete(filteredData)
    }
   
  }
 
  deleteNull(data) {
    this.spinner.show();
    let iserror = false;
    var bar = new Promise<void>((resolve, reject) => {
      data.forEach((element, index, array) => {
        const options = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
          }),
          body: {
            FeeTemplateCode: element.TemplateCode,
            StuId: element.StuId,
            FeeType: 'EF',
            FeeHead: element.HeadCode,
            FeeStatus: null,
            FeeAmt: element.FeeAmount,
            FeePaid: 0,
            FeeDue: element.FeeAmount,
            FeeDueDummy: element.FeeAmount,
            FeePaymentMethod: '',
            TotalPaidAmount: 0,
            PayMode: '',
            SnNo: element.SessionId,
            CreatedBy: '',
            TotalFeeAmount: 0
          },
        };
        this.httpClient.delete(this.APIService + '/fees/PayFeeDetails', options)
          .subscribe((s) => {
            let cc = [];
            cc.push(s);
            if (cc[0].status == false){
              this.spinner.hide();
              iserror = true;
              this.errMsg = cc[0].message
            }
            if (index === array.length -1) resolve();
            else {
              this.spinner.hide();
              iserror = false
              this.errMsg = cc[0].message
            }
            if (index === array.length - 1) resolve();
            // let cc = [];
            // cc.push(s);
            // let data = {}
            // data['message'] = cc[0].message
            // data['title'] = 'Information'
            // data['icon'] = 'fas fa-check'
            // this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
            // this.dialogRef.afterClosed().subscribe(result => {
 
            // });
          }, (ERROR: HttpErrorResponse) => {
            this.spinner.hide();
            if (index === array.length - 1) resolve();
            iserror = true;
            // let data = {}
            // data['message'] = ERROR.error.message
            // data['title'] = 'Alert'
            // data['icon'] = 'fas fa-close'
            // this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
            // this.ngOnInit();
            // this.umsService.openSnackbar(ERROR.error.message);
 
          });
      });
    });
 
    bar.then(() => {
      if(iserror == false){
        // this.finalSubmitNull(data);
        this.spinner.hide();
        data['message'] = 'Submitted Successfully'
            data['title'] = 'Information'
            data['icon'] = 'fas fa-check'
            this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
            this.dialogRef.afterClosed().subscribe(result => {
 
            });
            this.DeleteNull = true
      }
      else if(iserror == true){
        this.spinner.hide();
      }
    });
  }
 
  delete(data) {
    this.spinner.show();
    let iserror = false;
    var bar = new Promise<void>((resolve, reject) => {
      data.forEach((element, index, array) => {
        const options = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
          }),
          body: {
            FeeTemplateCode: element.TemplateCode,
            StuId: element.StuId,
            FeeType: 'EF',
            FeeHead: element.HeadCode,
            FeeStatus: 'N',
            FeeAmt: element.FeeAmount,
            FeePaid: 0,
            FeeDue: element.FeeAmount,
            FeeDueDummy: element.FeeAmount,
            FeePaymentMethod: '',
            TotalPaidAmount: 0,
            PayMode: '',
            SnNo: element.SessionId,
            CreatedBy: '',
            TotalFeeAmount: 0
          },
        };
        this.httpClient.delete(this.APIService + '/fees/PayFeeDetails', options)
          .subscribe((s) => {
            let cc = [];
            cc.push(s);
            if (cc[0].status == false){
              this.spinner.hide();
              iserror = true;
              this.errMsg = cc[0].message
            }
            if (index === array.length -1) resolve();
            else {
              this.spinner.hide();
              iserror = false
              this.errMsg = cc[0].message
            }
            if (index === array.length - 1) resolve();
            // let cc = [];
            // cc.push(s);
            // let data = {}
            // data['message'] = cc[0].message
            // data['title'] = 'Information'
            // data['icon'] = 'fas fa-check'
            // this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
            // this.dialogRef.afterClosed().subscribe(result => {
 
            // });
          }, (ERROR: HttpErrorResponse) => {
            this.spinner.hide();
            if (index === array.length - 1) resolve();
            iserror = true;
            // let data = {}
            // data['message'] = ERROR.error.message
            // data['title'] = 'Alert'
            // data['icon'] = 'fas fa-close'
            // this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
            // this.ngOnInit();
            // this.umsService.openSnackbar(ERROR.error.message);
 
          });
      });
    });
 
    bar.then(() => {
      if(iserror == false){
        this.spinner.hide();
        this.finalSubmit(data);
      }
      else if(iserror == true){
        this.spinner.hide();
      }
    });
  }
 
  finalSubmit(data){
    this.spinner.show()
    let iserror = false;
    var bar = new Promise<void>((resolve, reject) => {
      data.forEach((element, index, array)=> {
        let arr1 = [];
        arr1.push(
            this.fb.group({
             FeeTemplateCode: new FormControl(element.TemplateCode), //add neww
             StuId: new FormControl(element.StuId),
             FeeType: new FormControl('EF'),
             FeeHead: new FormControl(element.HeadCode),
             FeeStatus: new FormControl('N'),
              FeeAmt: new FormControl(element.FeeAmount),
              FeePaid: new FormControl(0),
              FeeDue: new FormControl(element.FeeAmount),
              FeeDueDummy: new FormControl (element.FeeAmount),
              FeePaymentMethod: new FormControl(''),
              TotalPaidAmount: new FormControl(0),
              PayMode:new FormControl(''),
              SnNo: new FormControl(element.SessionId),
              CreatedBy: new FormControl(''),
              TotalFeeAmount: new FormControl(0)
            })
          )
        this.umsService.addFee(arr1[0].value).subscribe(res => {
          if (res.status == false){
            this.spinner.hide();
            iserror = true;
            this.errMsg = res.message
          }
          if (index === array.length -1) resolve();
          else {
            this.spinner.hide();
            iserror = false
            this.errMsg = res.message
           
          }
        },
        (ERROR: HttpErrorResponse) => {
          this.spinner.hide();
          iserror = true;
          this.errMsg = ERROR.error.message
          if (index === array.length -1) resolve();
        }
        );
      });
    })
    bar.then(() => {
      this.spinner.hide();
      if(iserror == false && this.DeleteNull == false){
        this.spinner.hide();
        let  data = {}
        data['message'] = "Submitted Successfully"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
       
      }else if(iserror == true && this.DeleteNull == false){
        this.spinner.hide();
        let  data = {}
        data['message'] = this.errMsg
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
     
      }
    });
   
  }
 
}